import Stack from '@mui/material/Stack';

import { Pricing } from '../../../../contracts';
import { getFormattedNumber } from '../../../../utils/get-formatted-number';

interface FormattedPriceProps {
  pricing?: Pricing;
  priceValue?: number;
  'data-testid'?: string;
}

export function FormattedPrice({
  pricing,
  priceValue,
  'data-testid': dataTestId,
}: FormattedPriceProps) {
  const isNegativeNumber = priceValue ? priceValue < 0 : false;
  const formattedNumber = priceValue ? getFormattedNumber(Math.abs(priceValue), pricing) : '0';
  const { symbolPosition, currencySymbol, spacing } = pricing || {};
  return (
    <Stack direction={'row'} spacing={spacing ? 0.25 : 0} data-testid={dataTestId}>
      {isNegativeNumber ? '-' : ''}
      {symbolPosition === 'Left' && <span>{currencySymbol}</span>}
      <span>{formattedNumber}</span>
      {symbolPosition === 'Right' && <span>{currencySymbol}</span>}
    </Stack>
  );
}
